import moment from './moment'

const FormatUtcDateAsLocal = (date) => {
  return moment.utc(date).local().format("dddd, DD/MM/YYYY, HH:mm:ss.sss ZZ")
}

const FormatDate = (date) => {
  return moment(date).format("dddd, DD/MM/YYYY, HH:mm:ss.sss ZZ")
}

const IsSameDate = (date1, date2) => {
  return moment(date1).isSame(date2)
}

const ToRemainingTime = function (date) {
  let diff = moment.duration(moment(date).diff(moment()))
  return Math.round(parseInt(diff.asMinutes(), 10))
}

const CalculateTimeDiff = function (expected, actual) {
  return Math.round(parseInt(moment.duration(moment(actual).diff(moment(expected))).asMinutes(), 10))
}

export { FormatDate, FormatUtcDateAsLocal, ToRemainingTime, CalculateTimeDiff, IsSameDate }



// WEBPACK FOOTER //
// ./src/helpers/datetime.js